// Utilidad para asignar colores consistentes a routers

const ROUTER_COLORS = [
  { bg: 'bg-blue-100', border: 'border-blue-500', text: 'text-blue-700', badge: 'bg-blue-500' },
  { bg: 'bg-green-100', border: 'border-green-500', text: 'text-green-700', badge: 'bg-green-500' },
  { bg: 'bg-purple-100', border: 'border-purple-500', text: 'text-purple-700', badge: 'bg-purple-500' },
  { bg: 'bg-orange-100', border: 'border-orange-500', text: 'text-orange-700', badge: 'bg-orange-500' },
  { bg: 'bg-pink-100', border: 'border-pink-500', text: 'text-pink-700', badge: 'bg-pink-500' },
  { bg: 'bg-indigo-100', border: 'border-indigo-500', text: 'text-indigo-700', badge: 'bg-indigo-500' },
  { bg: 'bg-teal-100', border: 'border-teal-500', text: 'text-teal-700', badge: 'bg-teal-500' },
  { bg: 'bg-cyan-100', border: 'border-cyan-500', text: 'text-cyan-700', badge: 'bg-cyan-500' },
  { bg: 'bg-amber-100', border: 'border-amber-500', text: 'text-amber-700', badge: 'bg-amber-500' },
  { bg: 'bg-rose-100', border: 'border-rose-500', text: 'text-rose-700', badge: 'bg-rose-500' }
];

export const getRouterColor = (routerId, routers = []) => {
  if (!routerId || !routers.length) {
    return ROUTER_COLORS[0]; // Color por defecto
  }
  
  // Encontrar el índice del router en la lista
  const routerIndex = routers.findIndex(r => r.id === routerId);
  
  if (routerIndex === -1) {
    return ROUTER_COLORS[0];
  }
  
  // Usar módulo para ciclar los colores si hay más de 10 routers
  const colorIndex = routerIndex % ROUTER_COLORS.length;
  return ROUTER_COLORS[colorIndex];
};

export const getRouterName = (routerId, routers = []) => {
  const router = routers.find(r => r.id === routerId);
  return router ? router.name : 'Router desconocido';
};
